import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AudioFile } from '@model/audioFile';
import { Playlist } from '@model/playlist';
import { carouselAnimation, fadeAnimation } from '@util/animations';
import { BehaviorSubject } from 'rxjs';

export enum ADD_SONG_TO_PLAYLIST_VIEW {
  ADD_SONG_TO_PLAYLIST_VIEW_MAIN = "playlistViewMain",
  ADD_SONG_TO_PLAYLIST_VIEW_CREATE = "playlistViewCreate"
}

export const AddSongToPlaylistViewLevel = new Map<ADD_SONG_TO_PLAYLIST_VIEW, number>([
  [ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_MAIN, 0],
  [ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_CREATE, 1]
]);

@Component({
    selector: 'tun-add-song-to-playlist',
    templateUrl: './add-song-to-playlist.component.html',
    styleUrl: './add-song-to-playlist.component.scss',
    animations: [
        carouselAnimation,
        trigger('fadeIn', [
            transition(':enter', [
                useAnimation(fadeAnimation, { params: { duration: 10 } })
            ])
        ])
    ],
    standalone: false
})
export class AddSongToPlaylistComponent {
  @Input() tracks : AudioFile[] = [];
  @Input() showAddToQueue = false;

  @Output() addToPlaylist = new EventEmitter<Playlist>();
  @Output() addToQueue = new EventEmitter<void>();
  @Output() createAndAddToPlaylist = new EventEmitter<string>();

  constructor(

      private changeDetectorRef: ChangeDetectorRef,

    ) {

    }

  public CAROUSEL_DURATION = 300;
  public animationDirection: 'next' | 'prev' = 'next';

  public ADD_SONG_TO_PLAYLIST_VIEW = ADD_SONG_TO_PLAYLIST_VIEW;
    private _addSongToPlaylistView$ = new BehaviorSubject<ADD_SONG_TO_PLAYLIST_VIEW>(ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_MAIN);
    public set addSongToPlaylistView(view: ADD_SONG_TO_PLAYLIST_VIEW){
      if (this._addSongToPlaylistView$.value != view){
        if (AddSongToPlaylistViewLevel.get(this._addSongToPlaylistView$.value) < AddSongToPlaylistViewLevel.get(view)){
          this.animationDirection = 'next';
        }else{
          this.animationDirection = 'prev';
        }
        this.changeDetectorRef.detectChanges();
        this._addSongToPlaylistView$.next(view)
      }
    }
    public get addSongToPlaylistView$(){
      return this._addSongToPlaylistView$;
    }




    public onBackFromCreate(){
      this.addSongToPlaylistView = ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_MAIN;
    }

  public onCreateNewPlaylistWithName(name: string){
    this.createAndAddToPlaylist.emit(name);
  }

      public onAddToPlaylist(playlist: Playlist){
        this.addToPlaylist.emit(playlist);
      }

      public onSelectQueue(){
        this.addToQueue.emit();
      }

      public onCreatePlaylist(){
        this.addSongToPlaylistView = ADD_SONG_TO_PLAYLIST_VIEW.ADD_SONG_TO_PLAYLIST_VIEW_CREATE;
      }

      public textViewIsAnimating = false;
      public textViewAnimationStart(event: AnimationEvent){
        this.textViewIsAnimating = true;
      }
      public textViewAnimationDone(event: AnimationEvent){
        this.textViewIsAnimating = false;
      }
}
